var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.1-chats-empty",
    transform: "translate(-39.000000, -635.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component/Navigation/Left-Bar-Expanded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bottom"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 635.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "help",
    transform: "translate(39.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C13.9747148,0 18,4.02595313 18,9 C18,13.9747148 13.9740117,18 9,18 L9,18 L0.703125,18 C0.314789063,18 0,17.6852109 0,17.296875 L0,17.296875 L0,9 C0,4.02528516 4.02595313,0 9,0 Z M9,1.40625 C4.80258984,1.40625 1.40625,4.80315234 1.40625,9 L1.40625,9 L1.40625,16.59375 L9,16.59375 C13.1974102,16.59375 16.59375,13.1968477 16.59375,9 C16.59375,4.80258984 13.1968477,1.40625 9,1.40625 Z M8.72430469,12.0663281 C9.23902734,12.0663281 9.66789844,12.4952344 9.66789844,13.0099219 C9.66789844,13.512375 9.25122656,13.9535156 8.72430469,13.9535156 C8.19738281,13.9535156 7.79298047,13.5123398 7.79298047,13.0099219 C7.79298047,12.4952344 8.20965234,12.0663281 8.72430469,12.0663281 Z M8.88363281,4.92194531 C10.4521992,4.92194531 11.4938438,5.79202734 11.4938438,6.94395703 C11.4938438,8.09588672 10.4521992,8.92919531 10.1213438,9.18653906 C9.44736328,9.71346094 9.43505859,10.0810898 9.43505859,10.718332 C9.43505859,10.9511719 9.31253906,11.22075 8.71207031,11.22075 C8.20961719,11.22075 8.03808984,11.036918 8.03808984,10.3997109 C8.03808984,9.34583203 8.50376953,8.84337891 8.85912891,8.53702734 C9.26353125,8.19390234 9.94978125,7.81403906 9.94978125,7.15225781 C9.94978125,6.5885625 9.45959766,6.31894922 8.84685938,6.31894922 C7.59691406,6.31894922 7.86649219,7.26254297 7.20478125,7.26254297 C6.87389063,7.26254297 6.46952344,7.04197266 6.46952344,6.56402344 C6.46952344,5.90227734 7.22928516,4.92194531 8.88363281,4.92194531 Z",
    id: "Combined-Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.38b51f9bfeddca853b648eb7bb9d9744.svg";
export { ForwardRef as ReactComponent };